import { defineMessages } from '@sm/intl';

const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'Copy.FiveHundredErrorSorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  SOMETHING_WRONG: {
    id: 'Copy.FiveHundredErrorSomethingWentWrong',
    defaultMessage: 'Something went wrong.',
    description: '[Type: Label][Vis.: med] - something went wrong subtitle',
  },
  FIVE_HUNDRED_MESSAGE: {
    id: 'Copy.FiveHundredErrorFiveHundredMessage',
    defaultMessage:
      "Sorry if you lost your place - we're working hard to get things up and running again. Thanks for your patience!",
    description: '[Type: Label][Vis.: med] - Five Hundred Error Message',
  },
  HOME: {
    id: 'Copy.FiveHundredErrorHome',
    defaultMessage: 'Home',
    description:
      '[Type: Label][Vis.: med] - Home link in Five Hundred Error Message',
  },
  SITEMAP: {
    id: 'Copy.FiveHundredErrorSitemap',
    defaultMessage: 'Sitemap',
    description:
      '[Type: Label][Vis.: med] - Sitemap link in Five Hundred Error Message',
  },
  HELP_CENTER: {
    id: 'Copy.FiveHundredErrorHelpCenter',
    defaultMessage: 'Help Center',
    description:
      '[Type: Label][Vis.: med] - Help Center link in Five Hundred Error Message',
  },
  TEMPLATES: {
    id: 'Copy.FiveHundredErrorTemplates',
    defaultMessage: 'Templates',
    description:
      '[Type: Label][Vis.: med] - Templates link in Five Hundred Error Message',
  },
  LEARN_MORE: {
    id: 'Copy.FiveHundredErrorLearnMore',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis.: med] - Learn More link in Five Hundred Error Message',
  },
});

export default COPY;
